import { render } from "./It.vue?vue&type=template&id=672e2c89&scoped=true"
import script from "./It.vue?vue&type=script&lang=js"
export * from "./It.vue?vue&type=script&lang=js"

import "./It.vue?vue&type=style&index=0&id=672e2c89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672e2c89"]])

export default __exports__